import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap';
import bhote_news from '../Components/Home/news/news3.jpg';
import './BhoteKoshi.css';

const BhoteKoshi = () => {
  return (
    <Container className='bhote_container'>
        <Row className='bhote_row'>
        <h2 className='bhote_heading'>Bhote Koshi starts test generation.</h2>
            <Col>
            </Col>
            <Col xs={6}>
            <Image className='bhote_image' src={bhote_news} height="400px" width="100%" alt='picture'/>
            </Col>
            <Col>
            </Col>
            <p className='bhote_paragraph'><b>SINDHUPALCHOWK, Dec 9: Bhote Koshi Hydropower Project (45 MW)</b> has started power generation from Saturday.

The project faced multiple delays as it was affected by severe floods three and half years ago. The project started test generation after completing renovation of structures damaged by the floods.

Bikram Ratna Sthapit, general manager of Bhote Koshi Power Company, said that the project started test generation at 12 noon. "Electricity generated by the project has been connected to the national grid," he said, adding that the project will begin commercial generation after completion of 15-day test generation.

It took 20 months for the company to reconstruct structures damaged by the floods.

"We got permission to start test generation after Nepal Electricity Authority completed examining our structures and plant," Sthapit added. 

According to him, officials of the NEA studied the project for eight days. "We have tested both units of the plant. However, the plant is running to its full capacity as water flow in the river falls during winter months," he added. The plant is producing 22-25 MW at present,” he added. 


Water flow in Bhote Koshi River starts increasing from mid-March. The project will operate to its full capacity from mid-July, according to the project.

Chinese firm Sino Hydro 11 Bureau rebuilt the project on a 'fast track mode', said Sthapit. The project had to invest another Rs 7 billion for reconstruction works.

The floods had submerged the project's dam located in 10 Kilo area and deposited huge boulders and debris which also damaged other head works. 

The project was first hit by the 2015 earthquakes. Floods struck the project site when 80% of post-quake reconstruction was already completed, according to the company.

"We lost nearly 60% of the project cost due to the earthquakes and floods," said Sthapit, adding that the project cost has climbed to Rs 17 billion, up from the estimated Rs 10 billion.

Before the 2015 earthquakes, landslide of Jure had damaged transmission line of the project which halted power generation for nearly six months. Earthquake struck the project again four months after it had repaired the transmission line.


As the project has not been able to start generation since 2014, it is losing revenue of US$ 22-24 million annually, according to Sthapit.</p>
        </Row>
    </Container>
  )
}

export default BhoteKoshi;
